export enum Environment {
  mock = 'mock',
  development = 'development',
  dvit = 'dvit',
  fait = 'fait',
  abn = 'abn',
  production = 'production',
}
